import classnames from 'classnames';
import React from 'react';
import { Mask } from './mask';

const Collapse: React.FC<{ children?: React.ReactNode; isShowCollapse?: boolean; currentCollapse: string }> = ({
    children,
    currentCollapse,
    isShowCollapse = true,
}) => {
    return (
        <div
            className={classnames('p-editor__aside-collapse', `p-editor__menu-${currentCollapse}`, {
                active: isShowCollapse,
            })}
        >
            {children}
            <Mask type="collapse" />
        </div>
    );
};

export default Collapse;
